import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import MapSelector from '@/components/map/MapSelector'
// import ArcMap from '@/components/map/ArcMap'
import ProjectSelector from '@/components/project/ProjectSelector'
import Profile from '@/components/user/Profile'
import LogIn from '@/components/user/LogIn'
import SignUp from '@/components/user/SignUp'
import VisualizationSelector from '@/components/visualization/VisualizationSelector'
import ReportSelector from '@/components/report/ReportSelector'
import BasicReport from '@/components/report/BasicReport'
import ProjectMain from '@/components/ProjectMain'
import UserInfo from '@/components/user/UserInfo'
import WellMap from '@/components/map/WellMap'
import Dashboard from '@/components/project/Dashboard'
import DataChannelSelector from '@/components/project/DataChannelSelector'
import Community from '@/components/community/Community'
import VolumetricWaterViz from '@/components/visualization/VolumetricWaterArea'
import WeatherStation from '@/components/visualization/WeatherStation'
import TabularDataChannel from '@/components/project/TabularDataChannel'
// import WaterBasinUseMap from '@/components/animations/WaterBasinUseMap'
import LayerMap from '@/components/map/LayerMap'
import MapBox from '@/components/map/Mapbox'
import NotFound from '@/components/user/NotFound'
import VerifyEmail from '@/components/user/VerifyEmail'
import LandPKS from '@/components/visualization/LandPKS'
// import ReportEditor from '@/components/report/ReportEditor'
// import ZoomPicker from '@/components/animations/ZoomPicker'
import ZyptoBrewDemo from '@/components/expressModules/ZyptoBrewDemo'
import DataSlug from '@/components/project/DataSlug'
import {store} from '@/store'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {requiresAuth: false, requiresUser: false, requiresEmailVerification: false}
    },
    {
      path: '/zyptobrew',
      name: 'zyptobrew',
      component: ZyptoBrewDemo,
      meta: {requiresAuth: false, requiresUser: false, requiresEmailVerification: false}

    },
    // {
    //   path: '/zoompicker',
    //   name: 'ZoomPicker',
    //   component: ZoomPicker,
    //   meta: {requiresAuth: false, requiresUser: false, requiresEmailVerification: false}
    // },
    // {
    //   path: '/basin',
    //   name: 'WaterBasinUseMap',
    //   component: WaterBasinUseMap,
    //   meta: {requiresAuth: false, requiresUser: false, requiresEmailVerification: false}
    // },
    // {
    //   path: '/arcmap',
    //   name: 'bigmap',
    //   component: ArcMap,
    //   meta: {requiresAuth: true, requiresUser: true, requiresEmailVerification: true}
    // },
    {
      path: '/login',
      name: 'LogIn',
      component: LogIn,
      meta: {requiresAuth: false, requiresUser: false, requiresEmailVerification: false}
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp,
      meta: {requiresAuth: false, requiresUser: false, requiresEmailVerification: false}
    },
    {
      path: '/userinfo',
      name: 'UserInfo',
      component: UserInfo,
      meta: {requiresAuth: true, requiresUser: false, requiresEmailVerification: true}
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile,
      meta: {requiresAuth: true, requiresUser: true, requiresEmailVerification: false}
    },
    {
      path: '/projectSelector',
      component: ProjectSelector,
      name: 'ProjectSelector',
      meta: {requiresAuth: true, requiresUser: true, requiresEmailVerification: true}
    },
    // {
    //   path: '/reporteditor',
    //   component: ReportEditor,
    //   name: 'ReportEditor',
    //   meta: {requiresAuth: false, requiresUser: false, requiresEmailVerification: false}
    // },
    {
      path: '/verifyemail',
      component: VerifyEmail,
      name: 'VerifyEmail',
      meta: {requresAuth: true, requiresUser: false, requiresEmailVerification: false},
      beforeEnter: (to, from, next) => {
        if (store.getters['user/emailVerified']) {
          next('/projectSelector')
        } else {
          next()
        }
      }
    },
    {
      path: '/project/:projectid',
      component: ProjectMain,
      meta: {requiresAuth: true, requiresUser: true, requiresEmailVerification: true},
      beforeEnter: (to, from, next) => {
        store.dispatch('project/setProjectData', {projectID: to.params.projectid})
        next()
      },
      children: [
        {
          path: '',
          redirect: { name: 'Dashboard' }
        },
        {
          path: 'mapbox',
          name: 'mapbox',
          component: MapBox,
          meta: {requiresAuth: true, requiresUser: true, requiresEmailVerification: true}
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'reports',
          name: 'ReportSelector',
          component: ReportSelector,
          children: [
            {
              path: 'basicreport/:reportid',
              name: 'BasicReport',
              component: BasicReport
            }
          ]
        },
        {
          path: 'maps',
          name: 'MapSelector',
          component: MapSelector,
          children: [
            {
              path: 'wellmap/:wellMapId',
              name: 'WellMap',
              component: WellMap
            },
            {
              path: 'layermap',
              name: 'LayerMap',
              component: LayerMap
            },
            {
              path: 'mapbox',
              name: 'mapbox',
              component: MapBox,
              meta: {requiresAuth: true, requiresUser: true, requiresEmailVerification: true}
            }
            // {
            //   path: 'arcmap',
            //   name: 'arcmap',
            //   component: ArcMap
            // }
          ]
        },
        {
          path: 'visualizations',
          name: 'VisualizationSelector',
          component: VisualizationSelector,
          children: [
            {
              path: 'vwc/:vwcId',
              name: 'VolumetricWater',
              component: VolumetricWaterViz
            },
            {
              path: 'weatherStation/:stationID',
              name: 'WeatherStation',
              component: WeatherStation
            },
            {
              path: 'landpks',
              name: 'LandPKS',
              component: LandPKS
            }
          ]
        },
        {
          path: 'community',
          name: 'Community',
          component: Community
        },
        {
          path: 'data',
          name: 'DataEntry',
          component: DataChannelSelector,
          children: [
            {
              path: 'tabulardatachannel/:channelID',
              name: 'TabularDataChannel',
              component: TabularDataChannel
            },
            {
              path: 'dataslug/:channelID',
              name: 'DataSlug',
              component: DataSlug,
              props: true
            }
          ]
        }
      ]
    },
    {
      path: '*',
      name: 'NotFound',
      component: NotFound
    }

  ],
  mode: 'history'
})

router.beforeEach((to, from, next) => {
  store.dispatch('clearAlerts')
  let needsAuth = to.matched.some(record => record.meta.requiresAuth)
  let needsVerification = to.matched.some(record => record.meta.requiresEmailVerification)
  let needsUserName = to.matched.some(record => record.meta.requiresUser)
  let isAuthorized = store.getters['user/isLoggedIn']
  let hasUserName = (store.getters['user/displayName'] !== null)
  let isVerified = store.getters['user/emailVerified']
  // console.log('needs auth: ' + needsAuth)
  // console.log('needs ver: ' + needsVerification)
  // console.log('needs User: ' + needsUserName)
  // console.log('is auth: ' + isAuthorized)
  // console.log('hasUserName: ' + hasUserName)
  // console.log('is verifiec: ' + isVerified)
  if (needsAuth && !isAuthorized) {
    // console.log('to login')
    next('/login')
  } else if (needsVerification && !isVerified) {
    // console.log('to verify')
    next('/verifyemail')
  } else if (needsUserName && !hasUserName) {
    // console.log('to user info')
    next('/userinfo')
  } else {
    // console.log('to intended')
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js